import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 h-full xl:h-screen w-full pt-6 xl:pt-[88px] pb-6 px-4" }
const _hoisted_2 = { class: "relative items-center md:hidden" }
const _hoisted_3 = { class: "absolute left-0" }
const _hoisted_4 = { class: "text-2xl font-medium leading-[32px] text-brown" }
const _hoisted_5 = { class: "text-left md:mx-auto py-6 px-4 md:px-0 bg-white rounded-[20px] flex flex-col items-center w-full md:max-w-[812px] h-full min-h-0 overflow-y-auto no-scrollbar" }
const _hoisted_6 = { class: "relative hidden md:flex justify-center items-center w-full min-h-11 mb-2 px-10" }
const _hoisted_7 = { class: "absolute left-10" }
const _hoisted_8 = { class: "text-2xl font-semibold leading-[32px] text-brown" }

import PredictionResult from "@/views/Calculators/TarotPrediction/DailyPrediction/components/PredictionResult.vue";
import { ref } from "vue";
import { TarotDailyPredictionResponse } from "@/types/calculators";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { fetchTarotDailyPrediction } from "@/api/calculators";
import { useSafeBack } from "@/utils/useSafeBack";
import BackButton from "@/components/buttons/BackButton.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";
import PredictionInstruction from "@/views/Calculators/TarotPrediction/DailyPrediction/components/PredictionInstruction.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TarotDailyPrediction',
  setup(__props) {

const { t } = useI18n();
const { safeBack } = useSafeBack();

const loading = ref<boolean>(false);
const predictionResult = ref<TarotDailyPredictionResponse | null>(null);

async function getPrediction(): Promise<void> {
  loading.value = true;
  try {
    predictionResult.value = await fetchTarotDailyPrediction();
  } finally {
    loading.value = false;
  }
}

function handleBack() {
  if (predictionResult.value) {
    predictionResult.value = null;
    return;
  }
  safeBack(ROUTE_NAMES.TAROT);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BackButton, { onClicked: handleBack })
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("calculators.tarot.daily-card.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BackButton, { onClicked: handleBack })
        ]),
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)("calculators.tarot.daily-card.title")), 1)
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["text-sm font-normal leading-[20px] text-muted italic mb-10 md:px-10", { 'hidden md:block': predictionResult.value }])
      }, _toDisplayString(_unref(t)("calculators.tarot.daily-card.short-tip")), 3),
      (!predictionResult.value)
        ? (_openBlock(), _createBlock(GradientButton, {
            key: 0,
            class: "w-[225px] min-h-14 mb-10",
            "bg-color": "bg-brown-gradient",
            "hover-bg-color": "bg-orange-gradient",
            text: _unref(t)('calculators.tarot.daily-card.get-card-btn'),
            onClick: getPrediction,
            "is-loading": loading.value
          }, null, 8, ["text", "is-loading"]))
        : _createCommentVNode("", true),
      (!predictionResult.value)
        ? (_openBlock(), _createBlock(PredictionInstruction, { key: 1 }))
        : (_openBlock(), _createBlock(PredictionResult, {
            key: 2,
            result: predictionResult.value
          }, null, 8, ["result"]))
    ])
  ]))
}
}

})